import React from "react";
import {Typography} from "@mui/material";
import Box from '@mui/material/Box';
import {DeviceType, NORMAL_RANGE_GUIDE} from "../utils/deviceInfo";

// 화면 하단 정상범위 안내 (기기 분류별)
const DeviceNormalRange = (props: { deviceType: DeviceType }) => {
  const guide = NORMAL_RANGE_GUIDE[props.deviceType];

  if (guide === undefined) {
    return null;
  }

  return (
    <Box sx={{ p: 2 }}>
      <Typography sx={{ fontSize: 12, color: '#777', fontWeight: 700 }}>{guide.title}</Typography>
      {guide.lines.map((line) => (
        <Typography key={line} sx={{ fontSize: 12, color: '#888' }}>{line}</Typography>
      ))}
    </Box>
  );
}

export default DeviceNormalRange;
